export class UserRejectedSigningError extends Error {
  constructor(message = 'User rejected signing the transaction') {
    super(message);
    this.name = 'UserRejectedSigningError';
  }
}
